import type { CSSProperties } from "react";

/** 达人入驻页首屏 Hero 背景图（public 目录） */
export const CREATOR_APPLY_HERO_BG = `${process.env.PUBLIC_URL || ""}/bigv.jpg`;

function buildHeroGradient(widthPercent: number, endPercent: number): string {
  const start = Math.max(0, endPercent - widthPercent);
  const mid = start + widthPercent * 0.64;
  return `linear-gradient(to right, rgba(0, 0, 0, 0.08) 0%, rgba(0, 0, 0, 0.35) ${start}%, rgba(0, 0, 0, 0.82) ${mid}%, #000 ${endPercent}%, #000 100%)`;
}

/** 页面圆角 */
export const creatorApplyBorderRadius = {
  /** 平台理念卡片圆角（px） */
  featureCardPx: 10,
  /** 入驻登记整体卡片圆角（px） */
  formCardPx: 10,
  /** 入驻登记表单内输入框、按钮圆角（px） */
  formControlPx: 5,
} as const;

/** 首屏 Hero 布局 */
export const creatorApplyHeroStyle = {
  /** 右侧向黑渐变的过渡带宽度（视口宽度 %），调大渐变更宽、图片可见区域变窄 */
  gradientWidthPercent: 80,
  /** 渐变结束、进入纯黑的位置（视口左缘起算 %） */
  gradientEndPercent: 54,
  /** 文案区距视口左缘（%），调大文案整体右移 */
  copyOffsetLeftPercent: 70,
  /** 首屏文案区宽度（px），直接控制标题区域宽 */
  copyWidthPx: 550,
} as const;

/** 注入页面相关 CSS 变量（Hero 布局 + 圆角） */
export function creatorApplyCssVars(): CSSProperties {
  const {
    gradientWidthPercent,
    gradientEndPercent,
    copyOffsetLeftPercent,
    copyWidthPx,
  } = creatorApplyHeroStyle;
  const { featureCardPx, formCardPx, formControlPx } = creatorApplyBorderRadius;

  return {
    ["--ca-hero-image" as string]: `url(${CREATOR_APPLY_HERO_BG})`,
    ["--ca-hero-gradient" as string]: buildHeroGradient(
      gradientWidthPercent,
      gradientEndPercent
    ),
    ["--ca-hero-copy-offset-left" as string]: `${copyOffsetLeftPercent}%`,
    ["--ca-hero-copy-width" as string]: `${copyWidthPx}px`,
    ["--ca-radius-feature-card" as string]: `${featureCardPx}px`,
    ["--ca-radius-form-card" as string]: `${formCardPx}px`,
    ["--ca-radius-form-control" as string]: `${formControlPx}px`,
  };
}

/** @deprecated 使用 creatorApplyCssVars */
export const creatorApplyHeroCssVars = creatorApplyCssVars;
